import styled from 'styled-components';

export default styled.div`
  .wider-container {
    max-width: 1300px;
  }

  .content-wrapper {
    text-align: center;
  }

  .button-wrapper {
    margin-top: 20px;

    .pulsing {
      box-shadow: 0 0 0 0 rgba(247, 147, 30, 0.5);
      animation: pulse 1.2s infinite linear;
      -webkit-animation: pulse 1.2s infinite linear;
    }
    .pulsing:hover {
      animation: none;
      -webkit-animation: none;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.9);
      }
      50% {
        transform: scale(1);

        box-shadow: 0 0 0 25px rgba(247, 147, 30, 0);
      }
      100% {
        transform: scale(0.9);
        box-shadow: 0 0 0 0 rgba(247, 147, 30, 0);
      }
    }
  }
`;
